import { yup } from '@guiker/shared-framework'

export const checkBalancePayloadSchema = yup.object({
  amount: yup.number().required(),
})

export type CheckBalancePayloadSchema = yup.InferType<typeof checkBalancePayloadSchema>
